<template>
  <div v-if="asyncDataStatus_ready">

    <v-row justify="end">
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyBusinessUnitPricingNew'})"
        >
          Vnos
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <!-- <th>
                  Vrstna št.
                </th> -->
                <th>
                  Ime
                </th>
                <th>
                  Opis
                </th>
                <th>
                  Omogočeno
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(pricingInfo, index) in pricings"
                :key="pricingInfo.id"
              >
                <!-- <td>{{pricingInfo.label}}</td> -->
                <!-- <td>#{{index+1}}</td> -->
                <td>{{pricingInfo.name}}</td>
                <td>{{pricingInfo.description || 'Brez opisa'}}</td>
                <td><ActiveIcon :value="pricingInfo.is_active" /></td>
                <td class="text-right">
                  <ButtonActionEdit @click="$router.push({ name: 'MyCompanyBusinessUnitPricingEdit', params: { id: pricingInfo.id } })" />
                  <ButtonActionDelete @click="showDeleteAcceptanceFormModal = true; deleteAcceptanceForm = pricingInfo" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje nivoja cen"
      text="Ali ste prepričani, da želite izbrisati nivo cen? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteAcceptanceFormModal"
      @confirmed="remove(deleteAcceptanceForm)"
    />
  </div>
  <div v-else>
    {{'garara'}}
    <AppSpinner />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import ActiveIcon from '@/components/ActiveIcon'
import WriteoffFormsSearchForm from '@/components/WriteoffFormsSearchForm'

export default {
  components: {
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionDelete,
    ActiveIcon,
    WriteoffFormsSearchForm
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      pricings: [],
      showDeleteAcceptanceFormModal: false,
      deleteAcceptanceForm: null,
    }
  },
  methods: {
    ...mapActions('businessUnits', ['loadBusinessUnitPricing', 'deleteBusinessUnitPricing', 'setBusinessUnitPricingTime']),
    printInventoryForm (idwoform) {
      let routeData = this.$router.resolve({ name: 'MyCompanyInventoryFormPreview', params: { id: idwoform } })
      window.open(routeData.href, '_blank')
    },
    remove (item) {
      this.deleteBusinessUnitPricing(item.id)
        .then(() => {
          this.doLoadItems(this.$store.state.inventoryForms.filters)
          /* this.$notify({
            type: 'success',
            text: 'Element uspešno izbrisan.'
          }) */
        })
    },
    doLoadItems (filters) {
      this.loadBusinessUnitPricing()
        .then(res => {
          this.pricings = objectToArray(res)
          this.asyncDataStatus_fetched()
        })
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.pricings = []
      this.doLoadItems()
      // this.asyncDataStatus_fetched()
    }
  }
}
</script>
